// src/pages/Home.jsx

import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import HomeHero from "../components/Home/HomeHero";
import HomeTrustStrip from "../components/Home/HomeTrustStrip";
import HomeDoctor from "../components/Home/HomeDoctor";
// import HomeApproach from "../components/Home/HomeApproach";
import HomeServices from "../components/Home/HomeServices";
import HomeSwarnaprashana from "../components/Home/HomeSwarnaprashana";
// import HomeExperiences from "../components/Home/HomeExperiences";
import HomeRecognition from "../components/Home/HomeRecognition";
import HomeJournal from "../components/Home/HomeJournal";
import HomeActivities from "../components/Home/HomeActivities";
import HomeFinalCTA from "../components/Home/HomeFinalCTA";

import "./Home.css";
import "../components/Home/css/HomeShared.css";

const Home = () => {
  return (
    <div className="home-page">

      <Navbar />

      <main>

        <HomeHero />

        <HomeTrustStrip />

        <HomeDoctor />

        {/* <HomeApproach /> */}

        <HomeServices />

        <HomeSwarnaprashana />
        
        <HomeActivities />

        {/* <HomeExperiences /> */}

        <HomeRecognition />

        <HomeJournal />


        <HomeFinalCTA />

      </main>

      <Footer />

    </div>
  );
};

export default Home;